import Vue from 'vue'
import Vuex from 'vuex'
import globals from './modules/globals'
import boMember from './modules/boMember'
import member from './modules/member'
import image from './modules/image'
import pageBuilder from './modules/pageBuilder'
import course from './modules/course'
import product from './modules/product'
import page from '../page-lib/store'
import email from './modules/email'
import blog from './modules/blog'
import createLogger from '../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  ...globals,
  modules: {
    member,
    boMember,
    image,
    pageBuilder,
    course,
    page,
    product,
    email,
    blog,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})